import React, { Component } from 'react';
import './index.css';
import logo from '../../assets/images/inhand.png';
import { Link, withRouter } from 'react-router-dom';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Menu } from 'antd';
import menuList from '../../config/menuConfig';
import { connect } from 'react-redux';
import { setHeadTitle } from '../../redux/actions';

const { SubMenu } = Menu;
class LeftNav extends Component {
  /**
   * 根据menuList生成结构
   * @param {*} menuList
   * @returns
   */
  getMenuNodes = (menuList) => {
    const path = this.props.location.pathname;
    return menuList.reduce((pre, item) => {
      if (!item.children) {
        // 判断item是否是当前对应的item
        if (item.key === path || path.indexOf(item.key) === 0) {
          // 更新redux中的headerTitle状态
          this.props.setHeadTitle(item.title);
        }
        pre.push(
          <Menu.Item
            key={item.key}
            onClick={() => this.props.setHeadTitle(item.title)}>
            <Link to={item.key}>
              <LegacyIcon type={item.icon} />
              <span>{item.title}</span>
            </Link>
          </Menu.Item>
        );
      } else {
        const cItem = item.children.find((cItem) => cItem.key === path);
        if (cItem) {
          this.openKey = item.key;
        }
        pre.push(
          <SubMenu
            key={item.key}
            title={
              <span>
                <LegacyIcon type={item.icon} />
                <span>{item.title}</span>
              </span>
            }>
            {/* 二级菜单 */}
            {this.getMenuNodes(item.children)}
          </SubMenu>
        );
      }
      return pre;
    }, []);
  };

  componentWillMount() {
    this.menuNodes = this.getMenuNodes(menuList);
  }
  render() {
    let path = this.props.location.pathname;
    if (path.indexOf('/admin/client') === 0) {
      path = '/admin/client';
    }
    if (path.indexOf('/admin/user') === 0) {
      path = '/admin/user';
    }
    const openKey = this.openKey;
    return (
      <div className="left-nav">
        <Link to="/" className="left-nav-header">
          <img src={logo} alt="logo" />
        </Link>
        <Menu
          selectedKeys={[path]}
          defaultOpenKeys={[openKey]}
          mode="inline"
          theme="light">
          {this.menuNodes}
        </Menu>
      </div>
    );
  }
}

export default connect((state) => ({}), { setHeadTitle })(withRouter(LeftNav));
